<div class="contentContainer">
  <div *ngIf="userKind == 'ProviderUser'">
    <app-client-setup-provider></app-client-setup-provider>
  </div>
  <div *ngIf="userKind != 'ProviderUser'">
    <app-client-setup-item></app-client-setup-item>
  </div>
</div>
